import { getStore, usePlayerStore } from '../../../stores/StoreContext';
import CONSTANTS from '../../../config/constants';
import SplitView from '../../Common/SplitView';
import Sidebar from './Sidebar';
import Focused from './Focused';
import HoverControls from '../Controls/HoverControls';
import { View } from '@smarterservices/smarter-ui';
import Overlays from '../Overlays';
import { usePlayerHotkeys } from '../hooks/usePlayerHotkeys';
import { useSmartSpeed } from '../hooks/useSmartSpeed';
import { useEffect } from 'react';

const VideoRenderer = () => {
  const PlayerStore = getStore('playerStore');
  const LayoutStore = getStore('layoutStore');

  const splitValue = usePlayerStore((state) => state.videoPanelSplitPercentage);
  const showSidebar = usePlayerStore((state) => state.showSidebar || false);

  // Initialize all player hotkeys
  usePlayerHotkeys();

  // Initialize smart speed functionality
  useSmartSpeed();

  return (
    <View
      as="div"
      className="video-renderer-wrapper"
      position="relative"
      width="100%"
      height="100%"
      overflow="hidden"
      overflowY="hidden"
      onMouseEnter={() => PlayerStore.setShowHoverControls(true)}
      onMouseLeave={() => PlayerStore.setShowHoverControls(false)}
    >
      <SplitView
        direction="horizontal"
        firstContent={showSidebar ? <Sidebar /> : <></>}
        secondContent={<Focused />}
        initialSplit={showSidebar ? parseInt(splitValue) : 100}
        defaultSplit={CONSTANTS.PLAYER.DEFAULT_SIDEBAR_PCT}
        minFirstSize={20}
        minSecondSize={20}
        resizable={showSidebar ? true : false}
        splitPercentage={parseInt(splitValue)}
        onChange={(splitPercentage) => {
          PlayerStore.setVideoPanelSplitPercentage(splitPercentage);
        }}
        ref={(el) => {
          // Store the SplitView reference in LayoutStore
          if (el) {
            LayoutStore.setVideoSplitView(el);
          }
        }}
      />
      <HoverControls />
      <View as="div" textAlign="center" width="100%" height="100%">
        <Overlays />
      </View>
    </View>
  );
};

export default VideoRenderer;
